
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"110","height":"110","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 5a5 5 0 015-5h100a5 5 0 015 5v100a5 5 0 01-5 5H5a5 5 0 01-5-5V5z","fill":"#F3F3F3"}}),_c('path',{attrs:{"d":"M55 56.528c7.8 0 14.122-6.498 14.122-14.514C69.122 33.998 62.8 27.5 55 27.5c-7.799 0-14.122 6.498-14.122 14.514 0 8.016 6.323 14.514 14.122 14.514zM82.484 71.041c-.342-5.916-8.56-10.694-18.565-10.694H46.08c-10.005 0-18.224 4.778-18.565 10.694H27.5V82.5h55V71.04h-.016z","fill":"#C7C7C7"}})])
          )
        }
      }
    